<mat-toolbar one-double-area-toolbar oneTopbar class="qnsbn-double-global-topbar">

  <mat-toolbar-row one-double-area-row>
    <a href="https://diagnostics.roche.com/" title="Roche Diagnostics" target="_blank" one-topbar-title class="active" i18n="@@topbar.product-title">Roche Diagnostics</a>
    <span class="spacer"></span>
    <button [matMenuTriggerFor]="profileMenu" color="primary" mat-flat-button one-topbar-profile-button>
      <mat-icon>user</mat-icon>
      <span>{{ profileData.username }}</span>
    </button>
    <mat-menu #profileMenu="matMenu" xPosition="before" class="user-profile-dialog">
      <div class="profile-menu-topbar">
        <div class="icon-profile-menu-topbar">{{ userInitials }}</div>
        <div class="info-profile-menu-topbar">
          <div class="display-name-profile-menu-topbar">{{ profileData.name }}</div>
          <span class="mat-caption">{{ profileData.email }}</span>
        </div>
      </div>
      <mat-divider></mat-divider>
      <button class="btn-logout" mat-menu-item (click)="logout()">
        <mat-icon>standby</mat-icon>
        <span>Logout</span>
      </button>
      <mat-divider></mat-divider>
    </mat-menu>
    <mat-icon class="eservice-mat-globe-icon" mat-list-icon style="padding: 5px 10px;">globe</mat-icon>
    <span one-topbar-title i18n="@@topbar.product-title">Global/EN</span>
  </mat-toolbar-row>

  <mat-toolbar-row>
    
    <img (click)="toNotification()" title="QN/SBN" alt="Icon placeholder" class="icon-placeholder" src="assets/module_product-and-safety-care_default_without-background_512px.svg" style="cursor:pointer;"/>
    
    <span (click)="toNotification()" title="QN/SBN" one-topbar-title i18n="@@topbar.product-title" style="cursor:pointer;">QN/SBN</span>
    
    <span class="topbar-spacer"></span>
    
    <!-- Notification -->
    <div class="mat-tab-links" (click)="toNotification()">
      <a class="mat-tab-link" 
        [class.mat-tab-label-active]="activeTab === 'notification'"
        title="Notification">Notification</a>
      <span *ngIf="activeTab === 'notification'" class="mat-ink-bar"></span>
    </div>

    <!-- Dashboard -->
    <div class="mat-tab-links" (click)="toDashboard()">
      <a class="mat-tab-link"
        [class.mat-tab-label-active]="activeTab === 'dashboard'"
        title="Dashboard">Dashboard</a>
      <span *ngIf="activeTab === 'dashboard'" class="mat-ink-bar"></span>
    </div>

    <!-- Email Delivery -->
    <div class="mat-tab-links" (click)="toEmailDelivery()">
      <a class="mat-tab-link"
        [class.mat-tab-label-active]="activeTab === 'email-delivery'"
        title="Email delivery">Email delivery</a>
      <span *ngIf="activeTab === 'email-delivery'" class="mat-ink-bar"></span>
    </div>

    <span class="spacer"></span>
    
    <a href="https://diagnostics.roche.com/" title="Roche" target="_blank" style="align-items: center; display: flex;">
      <img alt="Roche logo" class="roche-logo" src="assets/logo_roche.svg" />
    </a>
  </mat-toolbar-row>

</mat-toolbar>
